import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import bannerImage from "../../Images/about/award-b.webp";
import award1 from "../../Images/awards/ISBMU-awards1.webp";
import award2 from "../../Images/awards/ISBMU-awards2.webp";
import award3 from "../../Images/awards/ISBMU-awards4.webp";
import award4 from "../../Images/awards/ISBMU-awards5.webp";
import award5 from "../../Images/awards/ISBMU-awards6.webp";
import award6 from "../../Images/awards/ISBMU-awards7.webp";
import award7 from "../../Images/awards/ISBMU-awards8.webp";
import award8 from "../../Images/awards/ISBMU-awards9.webp";
import award9 from "../../Images/awards/ISBMU-awards10.webp";
import award10 from "../../Images/awards/ISBMU-awards11.webp";
import award13 from "../../Images/awards/ISBMU-awards13.webp";
import indouk from "../../Images/awards/pharmaceutical.webp";
import nayabharat from "../../Images/awards/NAYA BHARAT.webp";
import apjabdul from "../../Images/awards/apj-award.webp";
import excelleneceAward from "../../Images/awards/ISBM University received the Excellence Award from Zee CG_MP News Channel.webp";
import india2047 from "../../Images/awards/india2047award.webp";
import award12 from "../../Images/awards/woodball.jpeg";

import awardslider1 from "../../Images/awards/AwardSlider/ASOCHM National Education Excellence Award 2017.webp";
import awardslider2 from "../../Images/awards/AwardSlider/ASSOCHM Education Excellence Award 2019.webp";
import awardslider3 from "../../Images/awards/AwardSlider/Best University in Central India for Placement 2023.webp";
import awardslider4 from "../../Images/awards/AwardSlider/Best Upcomming University Award 2024.webp";
import awardslider5 from "../../Images/awards/AwardSlider/CEGR Best Private University 2022.webp";
import awardslider6 from "../../Images/awards/AwardSlider/Center for Education Growth and Education 2023.webp";
import awardslider7 from "../../Images/awards/AwardSlider/Certificate for  Outstanding Academic Excellence Award.webp";
import awardslider8 from "../../Images/awards/AwardSlider/Certificate for Excellence in peer reviewing.webp";
import awardslider9 from "../../Images/awards/AwardSlider/Education Excellence Award 2024.webp";
import awardslider10 from "../../Images/awards/pharmaceutical.webp";
import awardslider11 from "../../Images/awards/apj-award.webp";
import awardslider12 from "../../Images/awards/AwardSlider/award 1.webp";
import awardslider13 from "../../Images/awards/AwardSlider/award 10.webp";
import awardslider14 from "../../Images/awards/AwardSlider/award 2.webp";
import awardslider15 from "../../Images/awards/AwardSlider/award 3.webp";
import awardslider16 from "../../Images/awards/AwardSlider/award 5.webp";
import awardslider17 from "../../Images/awards/AwardSlider/award 9.webp";
import awardslider18 from "../../Images/awards/AwardSlider/nayabharat.webp";
import awardslider19 from "../../Images/awards/AwardSlider/sushiksha chttisgardh 2018.webp";
import awardslider20 from "../../Images/awards/AwardSlider/year 2024 -Education Excellence Award – ISBM University, Chhattisgarh, 2024.webp";
import awardslider21 from "../../Images/awards/AwardSlider/award12.png";
import awardslider22 from "../../Images/awards/india2047award.webp";

const Awards = () => {
  const awards = [
    {
      id: 1,
      title: "Dainik Bhaskar Eminence Award",
      description:
        "The Hon'ble Vice Chancellor Dr. Anand Mahalwar and Registrar Dr. B.P. Bhol received the Dainik Bhaskar Eminence Award for the recognition of our countless contributions in the field of education.",
      image: award13,
      year: "",
      presenters: "Dainik Bhaskar",
    },
    {
      id: 2,
      title: "Best University in Chhattisgarh",
      description:
        "ISBM University is awarded the Best University in Chhattisgarh by the Honorable CM of Chhattisgarh, Shri Bhupesh Baghel.",
      image: award1,
      year: "",
      presenters: "Government of Chhattisgarh",
    },
    {
      id: 3,
      title: "Global Award 2019",
      description: "Global Award 2019 as Best Upcoming University by Auropath",
      image: award2,
      year: "2019",
      presenters: "Auropath",
    },
    {
      id: 4,
      title: "Certificate of Excellence",
      description:
        'ISBM University is awarded the "Certificate of Excellence" by Dr. Vinod Kumar Bhardwaj, State Nodal Officer, Innovations & Skill Development Programmes, Department of College Education, Government of Rajasthan on the occasion of 11th Higher Education & Human Resource Conclave, Pune.',
      image: award3,
      year: "2019",
      presenters: "Government of Rajasthan",
    },
    {
      id: 5,
      title: "Best University in Chhatisgarh 2019",
      description:
        "ISBM University is awarded Best University in Chhatisgarh 2019 by Shri Bhupesh Baghel, Hon. CM of Chhatisgarh.",
      image: award4,
      year: "2019",
      presenters: "Government of Chhattisgarh",
    },
    {
      id: 6,
      title: "Best University Promoting Government Digital Initiatives - 2019",
      description:
        "Awarded by ASSOCHAM on its Education Summit 2019. Presented by His Excellency Former President of India Shri Pranab Mukherjee and Hon. Minister for commerce and industry and civil aviation, Government of India 'Shri Suresh Prabhu' in Delhi.",
      image: award5,
      year: "2019",
      presenters: "ASSOCHAM",
    },
    {
      id: 7,
      title: "Most Emerging University 2018",
      description:
        "Awarded by Hon. Ex-Chief Minister of Uttarakhand State 'Shri Harish Rawat' at New Delhi.",
      image: award6,
      year: "2018",
      presenters: "Government of Uttarakhand",
    },
    {
      id: 8,
      title: "Best Upcoming University Award - 2018",
      description:
        "Awarded by Shri Purushottam Rupala, Hon'ble Minister of Agriculture and Panchayati Raj at World Education Summit in association with IndiaToday Group.",
      image: award7,
      year: "2018",
      presenters: "IndiaToday Group",
    },
    {
      id: 9,
      title: "The Best Upcoming University - 2017",
      description:
        "Awarded by the Hon. HRD Minister 'Shri Prakash Javdekar' in association with ASSOCHAM.",
      image: award8,
      year: "2017",
      presenters: "ASSOCHAM",
    },
    {
      id: 10,
      title: "Most Innovative University 2018",
      description:
        "Awarded by Hon. Chief Minister of Chhattisgarh 'Shri Raman Singh', Hon. Higher Education Minister of Chhattisgarh State 'Shri Prem Prakash Pandey' and Hon. School Education Minister of Chhattisgarh State 'Shri Kedar Kashyap' at Sushiksha event in Raipur.",
      image: award9,
      year: "2018",
      presenters: "News18 Network",
    },
    {
      id: 11,
      title: "Best Emerging Private University",
      description:
        'DR. D.M. Deshpande (Vice-Chancellor - ISBM University) receiving "The Best Emerging Private University" Award by Shri Raman Singh (Chief Minister - Chhattisgarh) and Shri Narendra Singh Tomar (Union Mines and Rural Development Minister).',
      image: award10,
      year: "",
      presenters: "News18 Network",
    },
    {
      id: 12,
      title: "Best University for Pharmecutical Studies",
      description:
        '"Best University for Pharmecutical Studies" by INDO-UK Global Business in the House of Lords,UK Parliament,London',
      image: indouk,
      year: "2022",
      presenters: "INDO-UK Global Business",
    },
    {
      id: 13,
      title: "For the Participation in Development",
      description: '"For the Participation in Development',
      image: nayabharat,
      year: "2024",
      presenters: "Naya Bharat",
    },
    {
      id: 14,
      title: "Dr. A.P.J. Abdul Kalam Inspiration Award",
      description:
        '"Dr. A.P.J. Abdul Kalam Inspiration Award" for Best Private University in India',
      image: apjabdul,
      year: "2024",
      presenters: "Topnotch Foundation",
    },
    {
      id: 15,
      title: "Excellence Award",
      description:
        "ISBM University received the Excellence Award from Zee CG/MP News Channel",
      image: excelleneceAward,
      year: "2024",
      presenters: "Zee CG/MP News Channel",
    },
    {
      id: 16,
      title: "Wins Gold in All India Inter University Woodball Tournament 2026",
      description:
        "ISBM University wins Gold at All India Inter University Woodball Tournament 2026",
      image: award12,
      year: "2026",
      presenters: "Wood Ball Award Committee",
    },
    {
      id: 17,
      title: "Leading Private University of the Year (Central India)",
      description:
        "ISBM University has been honoured as the Leading Private University of the Year (Central India) at the INDIA @2047 Leadership, Innovation & Global Power Summit & Awards 2026, held at IIT Delhi.",
      image: india2047,
      year: "2026",
      presenters: "Wood Ball Award Committee",
    },
  ];

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const awardImages = [
    awardslider1,
    awardslider2,
    awardslider3,
    awardslider4,
    awardslider5,
    awardslider6,
    awardslider7,
    awardslider8,
    awardslider9,
    awardslider10,
    awardslider11,
    awardslider12,
    awardslider13,
    awardslider14,
    awardslider15,
    awardslider16,
    awardslider17,
    awardslider18,
    awardslider19,
    awardslider20,
    awardslider21,
    awardslider22
  ];

  const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
      setIsReadMore(!isReadMore);
    };

    if (text.length > 100) {
      return (
        <p className="card-text">
          {isReadMore ? text.slice(0, 100) : text}
          <br />
          <button
            style={{ float: "right" }}
            onClick={toggleReadMore}
            className="small fw-medium bg-white border-0 text-blue"
          >
            {isReadMore ? "...Read More" : "Show Less"}
          </button>
        </p>
      );
    } else {
      return <p className="card-text">{text}</p>;
    }
  };

  return (
    <React.Fragment>
      <title>
        ISBM University Awards | Excellence in Education & Innovation
      </title>
      <meta
        name="description"
        content="Explore prestigious awards and recognitions from ISBM University for academic excellence, innovation, and contributions to higher education."
      />
      <Topnav />
      {/* Hero Banner */}
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Awards</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Awards
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="awards-intro-section ptb-50 bg-white">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <h2 className="modern-title section-title text-blue">
                Our Awards
              </h2>
              <p className="lead text-blue">
                ISBM University has been consistently recognized for its
                outstanding contributions to higher education, innovative
                teaching methodologies, and commitment to student success. These
                awards reflect our dedication to academic excellence and
                continuous improvement.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      {/* Awards Grid */}
      <section className="awards-section ptb-50 bg-light">
        <div className="container-xxl">
          <Row className="row-cols-1 row-cols-md-3 row-cols-lg-4 g-4">
            {awards.map((award) => (
              <div class="col">
                <div class="card h-100 shadow border-0">
                  <img
                    src={award.image}
                    class="card-img-top"
                    alt={award.title}
                  />
                  <div class="card-body">
                    <h4 class="card-title fw-bold">{award.title}</h4>
                    <ReadMore className="text-muted fw-normal">
                      {award.description}
                    </ReadMore>
                  </div>
                  <div class="card-footer text-purple">
                    <i className="ti ti-award"> </i>
                    <small class="text-body-secondary fw-semibold text-purple">
                      Awarded By:
                      <span className="fw-bold"> {award.presenters}</span>
                    </small>
                  </div>
                </div>
              </div>

              // <Col lg={4} md={6} key={award.id} className="award-col">
              //   <div className="award-card">
              //     <div className="award-front">
              //       <img src={award.image} alt={award.title} />
              //       <div className="award-year">{award.year}</div>
              //     </div>
              //     <div className="award-back">
              //       <h3>{award.title}</h3>
              //       <p className="presenter">By: {award.presenters}</p>
              //       <p className="description">{award.description}</p>
              //     </div>
              //   </div>
              // </Col>
            ))}
          </Row>
        </div>
      </section>
      <section className="awards-slider-section ptb-50 bg-light">
        <div className="container-xxl">
          <div className="awards-card-slider">
            <Slider {...sliderSettings}>
              {awardImages.map((image, index) => (
                <div key={index} className="px-2">
                  <div className="awardcard">
                    <div className="card-image-container">
                      <img
                        src={image}
                        alt={`Award Trophy ${index + 1}`}
                        className="card-image"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default Awards;
